import React from 'react';
import clsx from 'clsx';
import { alpha, ListSubheader, ListSubheaderProps, styled } from '@mui/material';
import NavLinkAdapter from '@fuse/core/NavLinkAdapter';

import FuseNavItem from '../../FuseNavItem';
import type { FuseNavProps } from '../../types/FuseNavProps';

interface RootProps extends ListSubheaderProps {
	itemPadding: number;
	to?: string;
}

const Root = styled(ListSubheader, { shouldForwardProp: name => name !== 'itemPadding' })<RootProps>(
	({ theme, itemPadding }) => ({
		height: 40,
		width: '100%',
		borderRadius: '6px',
		// margin: '24px 0 4px 0',
		margin: '4px 0 4px 0',
		paddingRight: 12,
		paddingLeft: itemPadding > 80 ? 80 : itemPadding,
		color: alpha(theme.palette.text.primary, 0.7),
		fontWeight: 600,
		letterSpacing: '0.025em'
	})
);

function FuseNavVerticalGroup(props: FuseNavProps) {
	const { item, nestedLevel, onItemClick } = props;

	const itemPadding = nestedLevel > 0 ? 28 + nestedLevel * 16 : 12;

	return React.useMemo(
		() => (
			<>
				<Root
					disableSticky
					itemPadding={itemPadding}
					className={clsx('fuse-list-subheader flex items-center', !item.url && 'cursor-default')}
					onClick={() => onItemClick && onItemClick(item)}
					component={item.url ? NavLinkAdapter : 'li'}
					to={item.url}
					role="button"
				>
					<span className="fuse-list-subheader-text text-12 uppercase">{item.title}</span>
				</Root>
				{item.children && (
					<>
						{item.children.map(_item => (
							<FuseNavItem
								key={_item.id}
								type={`vertical-${_item.type}`}
								item={_item}
								nestedLevel={nestedLevel}
								onItemClick={onItemClick}
							/>
						))}
					</>
				)}
			</>
		),
		[item, itemPadding, nestedLevel, onItemClick]
	);
}

const NavVerticalGroup = FuseNavVerticalGroup;

export default NavVerticalGroup;
